import { Zap } from "lucide-react"

export function AuthLayout({ children }) {
  return (
    <div className="flex min-h-screen flex-col bg-background font-sans selection:bg-primary/20 lg:flex-row">
      <aside className="relative hidden w-1/2 items-center justify-center overflow-hidden border-r border-border bg-muted/30 p-12 lg:flex">
        <div className="absolute inset-0 bg-primary/5">
          <div className="pointer-events-none absolute right-0 top-0 p-12 opacity-[0.03]">
            <Zap className="h-[40vw] w-[40vw]" />
          </div>
        </div>

        <div className="relative z-10 max-w-lg">
          <div className="mb-8 flex items-center gap-3">
            <div className="flex h-12 w-12 items-center justify-center rounded-xl border border-primary/30 bg-primary/20">
              <Zap className="h-6 w-6 text-primary" />
            </div>
            <h1 className="text-3xl font-bold tracking-tight text-foreground">Sentinel OS</h1>
          </div>

          <h2 className="mb-6 text-4xl font-bold leading-tight text-foreground">
            Institutional-grade deal origination &amp; analysis.
          </h2>

          <p className="mb-10 text-lg leading-relaxed text-muted-foreground">
            Deploy the primary execution engine to scan markets, evaluate capital structures, and
            identify high-yield investment opportunities.
          </p>

          <div className="flex items-center gap-4">
            <div className="flex items-center gap-2 rounded-full border border-border bg-background/50 px-4 py-2 font-mono text-xs backdrop-blur-sm">
              <div className="h-2 w-2 rounded-full bg-primary shadow-[0_0_8px_var(--color-primary)]" />
              <span className="text-primary">SYS.ONLINE</span>
            </div>
            <span className="text-sm font-medium uppercase tracking-widest text-muted-foreground">
              Restricted Access
            </span>
          </div>
        </div>
      </aside>

      <section className="relative flex w-full items-center justify-center p-6 sm:p-12 lg:w-1/2">
        <div className="absolute left-6 top-6 flex items-center gap-3 lg:hidden">
          <div className="flex h-8 w-8 items-center justify-center rounded-lg border border-primary/30 bg-primary/20">
            <Zap className="h-4 w-4 text-primary" />
          </div>
          <h1 className="text-lg font-bold tracking-tight text-foreground">Sentinel OS</h1>
        </div>

        {children}
      </section>
    </div>
  )
}
